import { Component, Input, ViewChild, AfterViewInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ChartHelper  } from '@helpers/index';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements AfterViewInit {
  @ViewChild('pieChartContainer')
  pieChartContainer: ElementRef;

  @Input() chartData: number[];
  public view: any[];
  pieChartColors = {
    domain: []
  };

  constructor(
    private chartHelper: ChartHelper,
    private cdRef: ChangeDetectorRef
  ) {
    this.pieChartColors.domain = this.chartHelper.backgroundColors;
  }

  ngAfterViewInit() {

    this.resizePieChart();
    fromEvent(window, 'resize').pipe(
      debounceTime(200))
      .subscribe(() => { this.resizePieChart() });
    this.cdRef.detectChanges();
  }

  resizePieChart() {
    this.view = [
      this.pieChartContainer.nativeElement.offsetWidth,
      this.pieChartContainer.nativeElement.offsetWidth < this.pieChartContainer.nativeElement.offsetHeight ?
      this.pieChartContainer.nativeElement.offsetWidth - 10:
      this.pieChartContainer.nativeElement.offsetHeight - 10
    ];
  }
}
